import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#333333] text-[#FFFFFF] py-10">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-6 md:mb-0 text-center md:text-left">
          <h3 className="text-xl font-bold text-[#FED700] mb-2">Bantrbox</h3>
          <p className="text-[#CCCCCC] text-sm">
            &copy; {new Date().getFullYear()} Bantrbox. All rights reserved.
          </p>
        </div>
        <div className="flex space-x-6 text-[#CCCCCC]">
          <Link to="/privacy" className="hover:text-[#FED700]">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-[#FED700]">
            Terms &amp; Conditions
          </Link>
          {/* Direct mailto link */}
          <a
            href="mailto:support@bantrbox.com"
            className="hover:text-[#FED700]"
          >
            Contact Us
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
